import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "antd";
import { AppDispatch, RootState } from "../../../../apis/store";
import { scroll } from "../../../../components/utils/utils";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import ContactUsList from "./ContactUslist";
import ContactUsModal from "./ContactUsModal";
import { getContactUsList } from "../../../../apis/actions/recipient.actions";
import CustomConfigProvider from "../../ProfileHeader";
const ContactUsOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  const { data: Contactus, loading } = useSelector(
    (state: RootState) => state?.recipient.ContactUs
  );
  const { TotalContactUs } = useSelector(
    (state: RootState) => state?.recipient
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  useEffect(() => {
    dispatch(getContactUsList({ limit: itemPerPage, page: currentPage }));
  }, [dispatch, currentPage]);
  return (
    <>
      <CustomConfigProvider title="تواصل معنا" />

      <Row
        justify={"space-between"}
        className="takaful--request-col-space"
        style={{ marginBottom: "2rem" }}
      >
        <Col xxl={4} xl={4} lg={5} md={5} sm={8} xs={8}>
          <PrimaryButton
            onClick={() => setIsModalVisible(true)}
            title="تواصل معنا"
            className="takaful--add-request-btn"
          />
        </Col>
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : Contactus?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد طلبات
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <ContactUsList
              requests={Contactus}
            />
          </Row>
          <div className="takaful--pagination-container">
            {Contactus && (Math.ceil(TotalContactUs) * itemPerPage) > itemPerPage && (
              <PaginationComponent
                active={currentPage}
                total={Math.ceil(TotalContactUs) * itemPerPage}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </>
      )}
      <ContactUsModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </>
  );
};

export default ContactUsOverview;
